module.exports = __webpack_public_path__ + "118c5546136b7d67daa584332e9c15ed.svg";